import { subDays } from 'date-fns';

import { HealthAssessmentFilters, NetworkRecommendationsFilters } from '../interfaces/filters';
import { Lane } from '../interfaces/services/lanes';
import { formatDateForApi } from './dateUtils';

const DELIMITER = '>';

export const getLaneId = (lane: Lane): string => {
    return `${lane.pickup_service_area_id}${DELIMITER}${lane.delivery_service_area_id}`;
};

export const parseLaneId = (laneId: string): { origin: string; destination: string; } => {
    const splitLaneId = laneId.split(DELIMITER);

    return {
        origin: splitLaneId[0],
        destination: splitLaneId[1],
    };
};

export const getFilterValuesFromParams = <T extends Record<string, any>>
    (
        valuePools: T[],
        comparatorField: string,
        filterParams: string[]
    ): T[] => {
    return valuePools.filter((valuePool) => {
        return filterParams.includes(valuePool[comparatorField]);
    });
};

export const formatHealthFilters = (): HealthAssessmentFilters => {
    return {
        earliest_delivery_departure_timestamp: formatDateForApi(subDays(new Date(), 31)),
        latest_delivery_departure_timestamp: formatDateForApi(subDays(new Date(), 1)),
        grading_basis_historical_start_date: formatDateForApi(subDays(new Date(), 31)),
        grading_basis_historical_end_date: formatDateForApi(subDays(new Date(), 1)),
        cleanse_data: true,
    };
};

export const formatNetworkRecommendationsFilters = (): NetworkRecommendationsFilters => {
    return {
        historical_start_date: formatDateForApi(subDays(new Date(), 31)),
        historical_end_date: formatDateForApi(subDays(new Date(), 1)),
        cleanse_data: true,
    };
};
